<template>
  <div class="spir-history">
    <table>
      <thead>
        <tr>
          <th>No.</th>
          <th>Course</th>
          <th>detail</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="history of histories" :key="history.no">
          <td>{{history.no}}</td>
          <td>
            <router-link :to="{
              name: 'StudentCourseGrades',
              params: {
                studentId,
                courseHistoryId: history.fromCourseHistoryId }
            }">
              {{history.fromCourseName}}
            </router-link>
            →
            <router-link :to="{
              name: 'StudentCourseGrades',
              params: {
                studentId,
                courseHistoryId: history.toCourseHistoryId }
            }">
              {{history.toCourseName}}
            </router-link>
          </td>
          <td>
            <router-link :to="{
              name: 'ApplicationDetail',
              params: { applicationId: history.applicationId }
            }">
              SPIR問い合わせ
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang='ts'>
import { Vue, Prop, Component } from 'vue-property-decorator'
import { SpirHistory } from '@/store/students/types';

@Component
export default class StudentSPIRHistory extends Vue {
  @Prop() histories!: SpirHistory[]

  private get studentId(): string {
    return this.$route.params.id
  }
}
</script>

<style scoped>
.spir-history {
  height: 420px;
  overflow-y: scroll;
}
table {
  width:100%;
  border-collapse:collapse;
  background: #fff;
  margin-bottom:10px;
}

table thead th, table thead td {
  padding: 20px;
}

table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

table th {
  padding:0 10px;
  text-align: center;
  background-color: #fff;
  position: sticky;
  top: 0;
  border-top:#fff;
}
th:before{
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-top: 2px solid #DBDBDB;
  border-bottom: 2px solid #DBDBDB;
}
th:first-child:before {
  border-left: 2px solid #DBDBDB;
}
th:last-child:before {
  border-right: 2px solid #DBDBDB;
}

table td {
  height: 50px;
  padding:5px 10px;
  text-align: center;
}

</style>
